import React from "react";
import { useNavigate } from "react-router-dom";

interface CustomerProps {
  item: any;
  index: number;
}
const CategoryItem: React.FC<CustomerProps> = ({ item, index }) => {
  const navigate = useNavigate();
  return (
    <div
      key={index}
      onClick={() => {
        navigate("/admin/add-category", { state: { item } });
      }}
      className="w-full my-2 cursor-pointer rounded-2xl border border-[pink] bg-white/70 hover:bg-[pink] hover:text-white transition-colors shadow-sm"
    >
      <div className="flex items-center gap-4 p-4">
        <div className="flex-1">
          <div className="text-sm opacity-70 mb-1">Tên Danh mục</div>
          <div className="font-medium">{item?.categoryName || "-"}</div>
        </div>
        
        <div className="flex-1">
          <div className="text-sm opacity-70 mb-1">Tên tiếng Anh</div>
          <div className="font-medium">{item?.categoryNameEn || "-"}</div>
        </div>
        
        <div className="flex-1">
          <div className="text-sm opacity-70 mb-1">Tên tiếng Hàn</div>
          <div className="font-medium">{item?.categoryNameKo || "-"}</div>
        </div>
      </div>
    </div>
  );
};
export default CategoryItem;
